import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createHocName from '../services/create-hoc-name';

const NAME = 'WithNavigation';

export default WrappedComponent => {
  class WithNavigation extends Component {
    constructor(props, context) {
      super(props, context);
      this.state = {
        navigation: this.context.navigation,
      };

      this.unsubscribe = this.context.subscribeToNavigationChange(navigation => this.setState({ navigation }));
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    static displayName = createHocName(NAME, WrappedComponent);
    render() {
      return <WrappedComponent {...this.props} navigation={this.state.navigation} />;
    }
  }

  WithNavigation.contextTypes = {
    navigation: PropTypes.object,
    subscribeToNavigationChange: PropTypes.func,
  };

  hoistNonReactStatics(WithNavigation, WrappedComponent);

  return WithNavigation;
};
